import {
  GET_TRANSPORTCOMPANIES_CATALOG,
  GET_TRANSPORTCOMPANIES_CATALOG_SUCCESS,
  GET_TRANSPORTCOMPANIES_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getTransportCompaniesCatalogRed = (
  state: any,
  actions: any
) => {
  switch (actions.type) {
    case GET_TRANSPORTCOMPANIES_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_TRANSPORTCOMPANIES_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_TRANSPORTCOMPANIES_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
